import React from 'react';
import styled from '@emotion/styled';

const IconWrapper = styled.span`
  color: #bdcad2;
`;

const Svg = styled.svg`
  width: 1.5em;
  height: 1.5em;
`;

export const SearchIcon = () => {
  return (
    <IconWrapper>
      <Svg viewBox="0 0 20.002 19.989">
        <path
          d="M1411.663,1335l-4.226-4.224a8.623,8.623,0,1,0-1.647,1.645l4.226,4.224a1.164,1.164,0,0,0,1.647-1.646Zm-17.332-9.412a6.267,6.267,0,1,1,6.267,6.262A6.271,6.271,0,0,1,1394.332,1325.591Z"
          transform="translate(-1392.002 -1317.001)"
        />
      </Svg>
    </IconWrapper>
  );
};

export default SearchIcon;
